import { createStore, compose } from 'redux';
import rootReducers from './reducer';

const composeEnhancer =
  (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

// create store
const store = createStore(rootReducers, {}, composeEnhancer());

export { store };
